import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import FavoriteMenuService from "services/FavoriteMenuService";

export const getFavoriteMenus = createAsyncThunk(
  "favoriteMenu/getFavoriteMenus",
  async (_, { rejectWithValue }) => {
    try {
      const response = await FavoriteMenuService.getFavoriteMenus();
      return response.data || [];
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const updateFavoriteMenus = createAsyncThunk(
  "favoriteMenu/updateFavoriteMenus",
  async ({ menus, onSuccess }, { rejectWithValue }) => {
    try {
      await FavoriteMenuService.updateFavoriteMenus(menus);
      if (onSuccess) onSuccess();
      return menus;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

const favoriteMenuSlice = createSlice({
  name: "favoriteMenu",
  initialState: {
    menus: [],
    loading: false,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFavoriteMenus.fulfilled, (state, action) => {
        state.menus = action.payload;
      })
      .addCase(updateFavoriteMenus.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateFavoriteMenus.fulfilled, (state, action) => {
        state.loading = false;
        state.menus = action.payload;
      })
      .addCase(updateFavoriteMenus.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default favoriteMenuSlice.reducer;
